import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  formatDateAndTimeWithoutLocal,
  formateDateAndTime,
  formateDateTime,
  formateDateWithTime,
  formateLocalDateAndTime,
} from "../../../utils/commonFunctions";
import { CalenderIcon, PaperClipIcon } from "../../Icon";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import moment from "moment";
import { CircularAvatar } from "../../commons";
type AppProps = {
  singleClientMeetUpCheckListData: any;

  loginData: LoginResponseType;
};
const ClientMeetUpDetailsModal = ({
  singleClientMeetUpCheckListData,
  loginData,
}: AppProps) => {
  return (
    <div>
      <div className="row  ml-2"></div>
      <div
        className="row ml-3 d-flex flex-column mb-2 mt-4"
        style={{
          border: "1px solid #bfcbe1",
          width: "93%",
          borderRadius: "6px",
        }}
      >
        <div className="ml-3 mt-3">
          <h5 style={{ fontSize: "15px", color: "#262a44", fontWeight: "600" }}>
            BASIC DETAILS
          </h5>
        </div>
        <div
          className="d-flex row justify-content-between ml-3 mb-3"
          style={{ width: "93%" }}
        >
          <div className="d-flex flex-column" style={{ width: "20%" }}>
            <span
              style={{
                color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
              }}
            >
              Client Code
            </span>
            <span style={{ color: "#262a44", fontSize: "14px" }}>
              {singleClientMeetUpCheckListData?.client_code
                ? singleClientMeetUpCheckListData?.client_code
                : "NA"}
            </span>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
              }}
            >
              Company Name
            </span>
            <span style={{ color: "#262a44", fontSize: "14px" }}>
              {singleClientMeetUpCheckListData?.company_name
                ? singleClientMeetUpCheckListData?.company_name
                : "NA"}
            </span>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
              }}
            >
              Name
            </span>
            <span style={{ color: "#262a44", fontSize: "14px" }}>
              {singleClientMeetUpCheckListData?.name
                ? singleClientMeetUpCheckListData?.name
                : "NA"}
            </span>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
              }}
            >
              Location
            </span>
            {singleClientMeetUpCheckListData?.city}{" "}
            {singleClientMeetUpCheckListData?.city ? "," : ""}{" "}
            {singleClientMeetUpCheckListData?.state}{" "}
            {singleClientMeetUpCheckListData?.state ? "," : ""}{" "}
            {singleClientMeetUpCheckListData?.country}
          </div>
        </div>
      </div>
      <div className="row ml-2" style={{ marginTop: "30px" }}>
        <div className="col-md-4 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Lead Received On"
            style={{
              color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
            }}
          >
            Current Software
          </label>
          <div style={{ display: "flex" }}>
            {/* {singleClientMeetUpCheckListData?.lead_received_on ? (
              <CalenderIcon />
            ) : (
              ""
            )} */}
            <p style={{ marginLeft: "4px" }}>
              {singleClientMeetUpCheckListData?.current_software
                ? singleClientMeetUpCheckListData?.current_software
                : "NA"}
            </p>
          </div>
        </div>
        <div className="col-md-4 pt-1 pb-1">
          <label
            htmlFor="businessNature"
            className="mb-1"
            style={{
              color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
            }}
          >
            Meet Up By
          </label>

          {singleClientMeetUpCheckListData?.meet_up_by?.first_name ||
          singleClientMeetUpCheckListData?.meet_up_by?.last_name ? (
            <div
              className="d-flex justify-content-sm-start"
              style={{ gap: "10px" }}
            >
              <CircularAvatar
                name={
                  singleClientMeetUpCheckListData?.meet_up_by?.first_name +
                  singleClientMeetUpCheckListData?.meet_up_by?.last_name
                }
                image={
                  singleClientMeetUpCheckListData?.meet_up_by?.profile_pic
                    ?.file_url
                }
              />
              {singleClientMeetUpCheckListData?.meet_up_by?.first_name +
                " " +
                singleClientMeetUpCheckListData?.meet_up_by?.last_name}
            </div>
          ) : (
            "NA"
          )}
        </div>
        <div className="col-md-4 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Demo Assigned To"
            style={{
              color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
            }}
          >
            Meet Up Status
          </label>
          <p 
           style={{
            color:singleClientMeetUpCheckListData?.meet_up_completed ? "#82b01f" :"#744bd1" ,
            background:singleClientMeetUpCheckListData?.meet_up_completed ? "#e7f0d4" : "#ede6fc",
            padding: "3px 10px",
            borderRadius: "16px",
            fontSize: "14px",
            fontWeight: "500",
            width:"fit-content"
          }}
          >
            {singleClientMeetUpCheckListData?.meet_up_completed
              ? "Completed"
              : "Pending"}
          </p>
        </div>
      </div>
      <div className="row ml-2">
        <div className="col-md-4 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Demo Assigned To"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Meeting Date and Time
          </label>
          <p>
            {singleClientMeetUpCheckListData?.meeting_time ? formatDateAndTimeWithoutLocal(singleClientMeetUpCheckListData?.meeting_time) : "NA"}
          </p>
        </div>
        <div className="col-md-4 pt-1 pb-1">
          <label
            className="mb-1"
            style={{
              color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
            }}
          >
            Number Of Bank Entries
          </label>
          <p>
            {singleClientMeetUpCheckListData?.number_of_banking_entries
              ? singleClientMeetUpCheckListData?.number_of_banking_entries
              : "NA"}
          </p>
        </div>
        <div className="col-md-4 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="meetingTimewithDate"
            style={{
              color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
            }}
          >
            Number Of Purchase Entries
          </label>
          <div style={{ display: "flex" }}>
            <p style={{ marginLeft: "4px" }}>
              {singleClientMeetUpCheckListData?.number_of_purchase_entries
                ? singleClientMeetUpCheckListData?.number_of_purchase_entries
                : "NA"}
            </p>
          </div>
        </div>
      </div>
      <div className="row ml-2">
        <div className="col-md-4 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Response"
            style={{
              color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
            }}
          >
            Number Of Sales Entries
          </label>
          <p>
            {singleClientMeetUpCheckListData?.number_of_sales_entries
              ? singleClientMeetUpCheckListData?.number_of_sales_entries
              : "NA"}
          </p>
        </div>
        <div className="col-md-4 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Stage"
            style={{
              color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
            }}
          >
            Old Work
          </label>
          <p>
            {singleClientMeetUpCheckListData?.old_work
              ? singleClientMeetUpCheckListData?.old_work
              : "NA"}
          </p>
        </div>
        <div className="col-md-4 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Stage"
            style={{
              color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
            }}
          >
            Remarks
          </label>
          <p>
            {singleClientMeetUpCheckListData?.remarks
              ? singleClientMeetUpCheckListData?.remarks
              : "NA"}
          </p>
        </div>
      </div>

      <div className="row ml-2">
        <div className="col-md-4 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Source"
            style={{
              color: "#6e7491",
              fontSize: "13px",
              marginBottom: "4px",
            }}
          >
            Scope Of Work
          </label>
          <div className="d-flex flex-row position-relative">
            <p>
              {singleClientMeetUpCheckListData?.scope_of_work
                ? singleClientMeetUpCheckListData?.scope_of_work
                : "NA"}
            </p>
          </div>
        </div>
        <div className="col-md-4 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Feedback"
            style={{
              color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
            }}
          >
            Starting Month Of Accounting
          </label>
          <p>
            {singleClientMeetUpCheckListData?.start_month_of_accounting
              ? singleClientMeetUpCheckListData?.start_month_of_accounting
              : "NA"}
          </p>
        </div>
        <div className="col-md-4 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Stage"
            style={{
              color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
            }}
          >
            Turnover Yearly
          </label>
          <p>
            {singleClientMeetUpCheckListData?.turnover_yearly
              ? singleClientMeetUpCheckListData?.turnover_yearly
              : "NA"}
          </p>
        </div>
      </div>

      <div className="row ml-2">
        <div className="col-md-4 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Stage"
            style={{
              color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
            }}
          >
            Working Hours In Client Place
          </label>
          <p>
            {singleClientMeetUpCheckListData?.working_hours_in_client_place
              ? singleClientMeetUpCheckListData?.working_hours_in_client_place
              : "NA"}
          </p>
        </div>

        <div className="col-md-4 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Stage"
            style={{
              color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
            }}
          >
            Business Type
          </label>
          <p>
            {singleClientMeetUpCheckListData?.business_type
              ? singleClientMeetUpCheckListData?.business_type
              : "NA"}
          </p>
        </div>

        <div className="col-md-4 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Stage"
            style={{
              color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
            }}
          >
            Lead Assigned By
          </label>
          <p>
            {/* {singleClientMeetUpCheckListData?.lead_assigned_by
              ? singleClientMeetUpCheckListData?.lead_assigned_by
              : "NA"} */}

            {singleClientMeetUpCheckListData?.lead_assigned_by?.first_name ||
            singleClientMeetUpCheckListData?.lead_assigned_by?.last_name ? (
              <div
                className="d-flex justify-content-sm-start"
                style={{ gap: "10px" }}
              >
                <CircularAvatar
                  name={
                    singleClientMeetUpCheckListData?.lead_assigned_by
                      ?.first_name +
                    singleClientMeetUpCheckListData?.lead_assigned_by?.last_name
                  }
                  image={
                    singleClientMeetUpCheckListData?.lead_assigned_by
                      ?.profile_pic?.file_url
                  }
                />
                {singleClientMeetUpCheckListData?.lead_assigned_by?.first_name +
                  " " +
                  singleClientMeetUpCheckListData?.lead_assigned_by?.last_name}
              </div>
            ) : (
              "NA"
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ClientMeetUpDetailsModal;
